import { ServerName } from "../env";
import { AIStandardEndpoint } from "./serverName";

export const getWhitelistedDomains = () => {
  const domains: string[] = [];
  if (ServerName !== "" && typeof ServerName === "string") {
    const { hostname } = new URL(ServerName);
    domains.push(hostname);
  }
  domains.push("localhost");
  const { hostname } = new URL(AIStandardEndpoint);
  domains.push(hostname);
  return domains;
};
